'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.default = genericWatcher;

var _effects = require('redux-saga/effects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(workerWrapper),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(genericWatcher);

// try / catch doesn't work properly around a fork task, so using it
// in a wrapped call task instead
function workerWrapper(worker, payload) {
    return _regenerator2.default.wrap(function workerWrapper$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(worker, payload);

                case 3:
                    return _context.abrupt('return', _context.sent);

                case 6:
                    _context.prev = 6;
                    _context.t0 = _context['catch'](0);
                    return _context.abrupt('return', { error: _context.t0 });

                case 9:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 6]]);
}

function genericWatcher(_ref) {
    var listenTo = _ref.listenTo,
        _ref$predicate = _ref.predicate,
        predicate = _ref$predicate === undefined ? function () {
        return true;
    } : _ref$predicate,
        request = _ref.request,
        worker = _ref.worker,
        success = _ref.success,
        failure = _ref.failure,
        cancelOn = _ref.cancelOn;

    var _ref2, _ref2$payload, payload, shouldProceed, task, racingTasks, _ref3, result, cancelled;

    return _regenerator2.default.wrap(function genericWatcher$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (!true) {
                        _context2.next = 42;
                        break;
                    }

                    _context2.next = 3;
                    return (0, _effects.take)(listenTo);

                case 3:
                    _ref2 = _context2.sent;
                    _ref2$payload = _ref2.payload;
                    payload = _ref2$payload === undefined ? {} : _ref2$payload;
                    _context2.next = 8;
                    return (0, _effects.call)(predicate, payload);

                case 8:
                    shouldProceed = _context2.sent;

                    if (!shouldProceed) {
                        _context2.next = 40;
                        break;
                    }

                    _context2.t0 = request;

                    if (!_context2.t0) {
                        _context2.next = 14;
                        break;
                    }

                    _context2.next = 14;
                    return (0, _effects.put)(request(payload));

                case 14:
                    _context2.next = 16;
                    return (0, _effects.fork)(workerWrapper, worker, payload);

                case 16:
                    task = _context2.sent;
                    racingTasks = { result: (0, _effects.join)(task) };

                    if (cancelOn) {
                        racingTasks.cancelled = (0, _effects.take)(cancelOn);
                    }
                    _context2.next = 21;
                    return (0, _effects.race)(racingTasks);

                case 21:
                    _ref3 = _context2.sent;
                    result = _ref3.result;
                    cancelled = _ref3.cancelled;

                    if (!cancelled) {
                        _context2.next = 29;
                        break;
                    }

                    _context2.next = 27;
                    return (0, _effects.cancel)(task);

                case 27:
                    _context2.next = 40;
                    break;

                case 29:
                    if (!(result && result.error)) {
                        _context2.next = 36;
                        break;
                    }

                    _context2.t1 = failure;

                    if (!_context2.t1) {
                        _context2.next = 34;
                        break;
                    }

                    _context2.next = 34;
                    return (0, _effects.put)(failure(result.error));

                case 34:
                    _context2.next = 40;
                    break;

                case 36:
                    _context2.t2 = success;

                    if (!_context2.t2) {
                        _context2.next = 40;
                        break;
                    }

                    _context2.next = 40;
                    return (0, _effects.put)(success(result));

                case 40:
                    _context2.next = 0;
                    break;

                case 42:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-redux/dist/sagas/WatcherCreatorHelper.js
// module id = 889
// module chunks = 0